import React, { useEffect, useState, useCallback } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import api from "../api/api";
import { styleDate, truncateText } from "../utils/Uility";
import { Paginate } from "../components/Paginate";
import { decrypt } from "../utils/CryptData";
import { toast } from "react-toastify";
import { emptyCart } from "../assets/images";

function Inventory() {
  const navigate = useNavigate();
  const loginState = useSelector((state) => state.auth.isLoggedIn);
  const userData = JSON.parse(decrypt(localStorage.getItem("dus"))) ?? {};
  const user = userData.user ?? [];
  const userEmail = user[0]?.email;

  const [histories, setHistories] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(true);

  const getOrder = useCallback(async (page = 1) => {
    if (!userEmail) return;
    setIsLoading(true);
    try {
      const history = await api.get(
        `/orders/OrderHistory/${userEmail}?page=${page}`,
        {
          headers: {
            "Content-type": "application/json",
            Accept: "application/json",
            Authorization: `Bearer ${
              JSON.parse(decrypt(localStorage.getItem("dus"))).token
            }`,
          },
        }
      );

      setCurrentPage(page);
      setTotalPages(history.data.totalPages ?? 1);
      setHistories(history.data.history ?? []);
    } catch (error) {
      toast.error("Erreur lors du chargement de vos commandes.");
    } finally {
      setIsLoading(false);
    }
  }, [userEmail]);

  const handlePageChange = async (page) => {
    setCurrentPage(page);
    await getOrder(page);
  };

  useEffect(() => {
    if (
      !loginState ||
      !JSON.parse(decrypt(localStorage.getItem("dus"))).token
    ) {
      navigate("/");
    } else {
      getOrder();
    }
  }, [loginState, getOrder, navigate]); // Include getOrder and navigate

  const tabHeader = [
    { title: "réference" },
    { title: "Produit" },
    { title: "Description" },
    { title: "Quantité" },
    { title: "Prix" },
    { title: "Date de Commande" },
  ];

  // Loading skeleton
  const TableSkeleton = () => (
    <div className="animate-pulse">
      <div className="h-10 bg-gray-200 rounded mb-4"></div>
      {[...Array(5)].map((_, i) => (
        <div key={i} className="flex gap-4 mb-4">
          <div className="w-20 h-20 bg-gray-200 rounded"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
            <div className="h-4 bg-gray-100 rounded w-1/2"></div>
          </div>
        </div>
      ))}
    </div>
  );

  return (
    <div className="w-11/12 lg:w-11/12 m-auto my-12 ">
      {isLoading ? (
        <div className="bg-white p-8 rounded-lg">
          <h1 className="text-3xl uppercase text-center mb-12">Chargement de vos commandes...</h1>
          <TableSkeleton />
        </div>
      ) : histories.length ? (
        <>
          <h1 className="text-3xl uppercase text-center mb-12 flex items-center justify-center gap-3">
            Vos commandes{" "}
            <svg
              className="h-10 w-10"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 576 512"
            >
              <path d="M24 0C10.7 0 0 10.7 0 24S10.7 48 24 48l45.5 0c3.8 0 7.1 2.7 7.9 6.5l51.6 271c6.5 34 36.2 58.5 70.7 58.5L488 384c13.3 0 24-10.7 24-24s-10.7-24-24-24l-288.3 0c-11.5 0-21.4-8.2-23.6-19.5L170.7 288l288.5 0c32.6 0 61.1-21.8 69.5-53.3l41-152.3C576.6 57 557.4 32 531.1 32L360 32l0 102.1 23-23c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-64 64c-9.4 9.4-24.6 9.4-33.9 0l-64-64c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l23 23L312 32 120.1 32C111 12.8 91.6 0 69.5 0L24 0zM176 512a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm336-48a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z" />
            </svg>
          </h1>
          <table className="min-w-full bg-white">
            <thead>
              <tr className="w-full bg-gray-900 text-gray-300 uppercase text-sm leading-normal">
                {tabHeader.map((item, index) => (
                  <th key={index} className="py-3 px-6 text-left">
                    {item.title}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody className="text-gray-600 text-sm font-light">
              {histories.map((item, index) => (
                <tr
                  key={index}
                  className="border-b border-gray-200 hover:bg-gray-100"
                >
                  <td className="py-3 px-6">
                    {truncateText(item.product_id, 20)}
                  </td>
                  <td className="py-3 px-6 flex items-center">
                    <img
                      src={
                        item.product_image
                          ? `${process.env.REACT_APP_BACK_URL}${item.product_image}`
                          : "./shopping.svg"
                      }
                      alt={item.product_name}
                      className="object-cover object-center w-20 h-20 rounded"
                    />
                    <span className="ml-2">{item.product_name}</span>
                  </td>
                  <td className="py-3 px-6">{item.product_description}</td>
                  <td className="py-3 px-6">
                    Qty: {item.quantity} x {item.price_per_unit}{" "}
                    {item.product_unit}
                  </td>
                  <td className="py-3 px-6">
                    {item.quantity * item.price_per_unit}
                  </td>
                  <td className="py-3 px-6">{styleDate(item.order_date)}</td>
                </tr>
              ))}
            </tbody>
          </table>
          {histories && (
            <Paginate
              listproductLength={{ page: currentPage, totalPages: totalPages }}
              handlePage={handlePageChange}
            />
          )}
        </>
      ) : (
        <div className="card bg-white w-4/5 mx-auto my-12 p-8">
          <figure>
            <img className="w-1/2" src={emptyCart} alt="Panier vide" />
          </figure>
          <div className="card-body">
            <h2 className="card-title mx-auto">Pas de commande effectué</h2>
          </div>
        </div>
      )}
    </div>
  );
}

export default Inventory;
